import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import ContactLifeCycleActivityActions from 'modules/domain/contactLifeCycleActivity/duck'
import * as managers from './managers'
import ContactLifeCycleActivitySelectors from './selectors'
import { ContactLifeCycleActivity } from 'modules/domain/contactLifeCycleActivity/types'
import { ListResponse } from 'types/api'
import { RequestError } from 'modules/errors'

export const fetchList = function* () {
  try {
    let currentPage = yield select(ContactLifeCycleActivitySelectors.page)
    const filter = yield select(ContactLifeCycleActivitySelectors.filter)
    const sorting = yield select(ContactLifeCycleActivitySelectors.sorting)
    const pageSize = yield select(ContactLifeCycleActivitySelectors.pageSize)

    let response: ListResponse<ContactLifeCycleActivity> = yield call(
      managers.getContactLifeCycleActivitiesList,
      filter,
      sorting,
      currentPage,
      pageSize,
    )
    const pages = Math.ceil(response.total_count / pageSize)
    if (pages !== 0 && pages < currentPage) {
      response = yield call(managers.getContactLifeCycleActivitiesList, filter, sorting, pages, pageSize)
      currentPage = pages
    }

    const { data, page, total_count } = response
    yield put(ContactLifeCycleActivityActions.listRequestSucceed(data, total_count, page))
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(ContactLifeCycleActivityActions.listRequestFailed(errType))
  }
}

export const fetchListNext = function* () {
  try {
    const page = yield select(ContactLifeCycleActivitySelectors.page)
    const filter = yield select(ContactLifeCycleActivitySelectors.filter)
    const sorting = yield select(ContactLifeCycleActivitySelectors.sorting)
    const pageSize = yield select(ContactLifeCycleActivitySelectors.pageSize)
    const { data, total_count }: { data: ContactLifeCycleActivity[]; total_count: number } = yield call(
      managers.getContactLifeCycleActivitiesList,
      filter,
      sorting,
      page,
      pageSize,
    )
    yield put(ContactLifeCycleActivityActions.listRequestNextSucceed(data, total_count))
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(ContactLifeCycleActivityActions.listRequestNextFailed(errType))
  }
}

export const fetchContactLifeCycleActivity = function* ({
  payload: id,
}: ReturnType<typeof ContactLifeCycleActivityActions.itemRequested>) {
  try {
    const contactLifeCycleActivity: ContactLifeCycleActivity = yield call(managers.getContactLifeCycleActivity, id)
    yield put(ContactLifeCycleActivityActions.itemRequestSucceed(contactLifeCycleActivity))
  } catch (err) {
    const errType = err instanceof RequestError ? err.type : 'unknown'
    yield put(ContactLifeCycleActivityActions.itemRequestFailed(id, errType))
  }
}

const ContactLifeCycleActivitiesSaga = function* () {
  yield all([
    takeLatest(ContactLifeCycleActivityActions.itemRequested.type, fetchContactLifeCycleActivity),

    takeLatest(ContactLifeCycleActivityActions.listRequested.type, fetchList),
    takeLatest(ContactLifeCycleActivityActions.filterUpdated.type, fetchList),
    takeLatest(ContactLifeCycleActivityActions.sortingUpdated.type, fetchList),
    takeLatest(ContactLifeCycleActivityActions.filterHasBeenReset.type, fetchList),
    takeLatest(ContactLifeCycleActivityActions.sortingHasBeenReset.type, fetchList),

    takeLatest(ContactLifeCycleActivityActions.listRequestedNext.type, fetchListNext),
  ])
}

export default ContactLifeCycleActivitiesSaga
